import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material";

import { AuthenticationService } from "../authentication/authentication.service";
import { LoggedInUser } from "../authentication/user";
import { isCognitoUser } from "../authentication/cognito-user";
import { DeleteAccountConfirmationComponent } from "./delete-account/delete-account.component";
import { getPath } from "../../util";
import { NavigationService } from "../navigation/navigation.service";

@Component({
	selector: "sdp-header",
	templateUrl: "./header.component.html",
	providers: []
})

export class HeaderComponent implements OnInit {
	public sub: any;
	public isLoggedIn = false;
	public user: LoggedInUser | undefined;
	public isNotWizard = false;
	public readonly vertIcon = { type: "material", name: "more_vert", cssClass: "sdp-header-more-icon" };

	constructor(
		public dialog: MatDialog,
		private auth: AuthenticationService,
		private route: Router,
		private navigationService: NavigationService,
	) {
	}

	public ngOnInit() {
		this.sub = this.route.events.subscribe(async () => {
			this.isNotWizard = getPath(this.route.url) !== "wizard";
			this.isLoggedIn = this.auth.isLoggedIn();

			if (this.isLoggedIn) {
				this.user = this.auth.getCurrentUser();
			}
		});
	}

	public logout() {
		this.auth.logout();
	}

	public goTo(loc: string) {
		this.navigationService.navigate([`/${loc}`]);
	}

	public goToUserSettings() {
		if (!!this.user) {
			if (this.user.admin) {
				this.goTo("administration/settings");
			} else {
				this.goTo("user/settings");
			}
		}
	}

	public async deleteAccount() {
		// TODO open dialog here
		const currentUser = this.auth.getCurrentUser();
		if (!currentUser) {
			this.navigationService.navigate(["login/login"]);
			return;
		}
		const dialogRef = this.dialog.open(
			DeleteAccountConfirmationComponent,
			{
				data: currentUser.accountName
			}
		);
		dialogRef.afterClosed().subscribe(async (result: boolean) => {
			if (result) {
				this.auth.logout();
			}
		});
	}

	public get showReset() {
		if (!!this.user) {
			return isCognitoUser(this.user);
		} else {
			return false;
		}
	}
}
